module.exports = __webpack_public_path__ + "static/sm-1-26729b90cc8325b9316fd5a21f51bd21.png";